<div class="d-flex justify-content-center align-items-center vh-100">
  <nz-result nzStatus="404" [nzTitle]="MESSAGES.pageNotFoundTitle">
    <div nz-result-extra>
      <button nz-button nzType="primary" nzSize="large" class="px-5" (click)="back()">Back to Home</button>
    </div>
  </nz-result>
</div>
